var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.331,
    height: 26.5,
    viewBox: "0 0 23.331 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Online_Support",
    transform: "translate(-54.75 -18.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    d: "M58.083,229.166a3.337,3.337,0,0,1-3.333-3.333v-3.75a3.333,3.333,0,0,1,6.666,0v3.75A3.337,3.337,0,0,1,58.083,229.166Zm0-7.916a.834.834,0,0,0-.833.833v3.75a.833.833,0,0,0,1.666,0v-3.75A.834.834,0,0,0,58.083,221.25Z",
    transform: "translate(0 -189.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    "data-name": "Path 3723",
    d: "M378.083,229.166a3.337,3.337,0,0,1-3.333-3.333v-3.75a3.333,3.333,0,0,1,6.666,0v3.75A3.337,3.337,0,0,1,378.083,229.166Zm0-7.916a.834.834,0,0,0-.833.833v3.75a.833.833,0,0,0,1.666,0v-3.75A.834.834,0,0,0,378.083,221.25Z",
    transform: "translate(-303.335 -189.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724",
    "data-name": "Path 3724",
    d: "M76.831,33.749a1.25,1.25,0,0,1-1.25-1.25V30.416a9.166,9.166,0,1,0-18.331,0V32.5a1.25,1.25,0,0,1-2.5,0V30.416a11.666,11.666,0,1,1,23.331,0V32.5A1.25,1.25,0,0,1,76.831,33.749Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725",
    "data-name": "Path 3725",
    d: "M300.166,339.5H296a1.25,1.25,0,0,1,0-2.5h4.166a2.92,2.92,0,0,0,2.916-2.916V332a1.25,1.25,0,0,1,2.5,0v2.083A5.422,5.422,0,0,1,300.166,339.5Z",
    transform: "translate(-227.501 -296.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    d: "M2.057-1.25A3.307,3.307,0,1,1-1.25,2.057,3.311,3.311,0,0,1,2.057-1.25Zm0,4.114a.807.807,0,1,0-.807-.807A.808.808,0,0,0,2.057,2.864Z",
    transform: "translate(64.359 39.886)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineSupport);
export default __webpack_public_path__ + "static/media/Online_Support.79cce6b0b1e048407621d70cdb366878.svg";
export { ForwardRef as ReactComponent };